import { SellerFragment } from '@gql'
import { createModel } from '../../../store/generic'

export default createModel<SellerFragment>()
